export default "/images/7bb418d1b3bfc33479a0dfc1e125b769.avif";